import { isFunction } from 'lodash';
import {postBlockUser} from '../api/postBlockUser';
import {setGetUserById} from './setGetUserById';

const setPostBlockUser = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await postBlockUser(params);
            dispatch(setGetUserById(params.id));
            if (isFunction(callback)) {
                callback();
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostBlockUser
}